import { Flex } from 'antd';
import SelectComponent from 'components/Select';
import RBCountryFilter from 'components/UniversalFilters/RBCountryFilter';
import { FARMER_STATUS } from 'utils/constants';

interface TopFiltersProps {
  country: string | null;
  onCountryChange: (value: string) => void;
  farmerStatus: string | null;
  onFarmerStatusChange: (value: string) => void;
}
const TopFilters = ({
  country,
  onCountryChange,
  farmerStatus,
  onFarmerStatusChange,
}: TopFiltersProps) => {
  return (
    <Flex gap={20} align="center" wrap="wrap">
      <RBCountryFilter
        selectedCountry={country as string}
        onChange={onCountryChange}
      />
      <SelectComponent
        label="Status"
        options={FARMER_STATUS}
        value={farmerStatus}
        onChange={onFarmerStatusChange}
      />
    </Flex>
  );
};

export default TopFilters;
